import $ from 'jquery';

function initSlider() {
    $('.js-museum-reviews-slider').slick({
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        responsive: [
        {
            breakpoint: 1023,
            settings: {
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                infinite: false,
           }
        }
        ]
    });
}

$(document).ready(function() {
    initSlider();
    
    $(document).on('click', '.js-vi-button', function() {
        if ($('.b-vi-top-control').is(":visible")) {
            $('.js-museum-reviews-slider').slick('destroy');
        } else {
            initSlider();
        }
    });
    $(document).on('click', '.b-vi-top-control__version', function() {
        initSlider();
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/one-museum/museum-reviews-slider.js